<template>
    <div>
        <b-modal
            v-model="isModalVisible"
            hide-footer
            :title="model.id ? 'View Message' : 'Add Message'"
        >
            <b-form-group
                id="fieldset-received"
                label="Received"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.created_at | displayTime }}
            </b-form-group>
            <b-form-group
                id="fieldset-sender"
                label="Sender"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.user | displayUser }}
            </b-form-group>
            <b-form-group
                id="fieldset-1"
                label="Message"
                label-for="input-content"
                label-cols="3"
                label-class="font-weight-bold pt-0"
            >
                <b-form-textarea
                    :disabled="!!model.id"
                    id="input-content"
                    v-model="model.content"
                    placeholder="Enter Message..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <b-button
                size="sm"
                @click="isModalVisible = false"
                variant="warning"
                class="mr-3"
                >Close</b-button
            >
            <b-button
                v-show="!model.id"
                size="sm"
                @click="createMessage"
                v-if="hasPermissionCreate"
                :disabled="submitting ? true : false"
                variant="primary"
                >Add Message</b-button
            >
        </b-modal>
        <b-button
            size="sm"
            variant="primary"
            v-if="hasPermissionCreate"
            @click="
                model.content = ''
                model.id = null
                isModalVisible = true
            "
            >Add Message</b-button
        >
        <b-table
            id="orderTable"
            :items="messages"
            :fields="fields"
            :busy="tableLoading"
            small
            striped
            selectable
            responsive
            show-empty
            ref="selectableTable"
        >
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template #empty>
                <h4 v-html="emptyText"></h4>
            </template>
            <template #emptyfiltered>
                <h4 v-html="emptyText"></h4>
            </template>

            <template #cell(actions)="{ item }">
                <b-button
                    size="sm"
                    v-if="hasPermissionView"
                    @click="viewNote(item)"
                    class="mr-2"
                    variant="primary"
                >
                    View
                </b-button>
                <b-button
                    size="sm"
                    variant="warning"
                    v-if="hasPermissionDelete"
                    @click="deleteMessage(item.hash)"
                    :disabled="submitting ? true : false"
                    >{{ 'Delete' }}</b-button
                >
            </template>

            <template #cell(id)="{ index }">
                <h6>
                    {{ index + 1 }}
                </h6>
            </template>

            <template #cell(content)="{ value }">
                <h6>
                    {{ value.length > 40 ? value.slice(0, 40) + '---' : value }}
                </h6>
            </template>

            <template #cell(created_at)="{ value }">
                <h6>
                    {{ value | displayTime(true) }}
                </h6>
            </template>

            <template #cell(user_id)="{ item }">
                <h6>
                    {{ item.user | displayUser }}
                </h6>
            </template>
        </b-table>
    </div>
</template>

<script>
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-notes',
    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            model: {},
            isModalVisible: false,
            tableLoading: false,
            submitting: false,
            fields: [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: 'actions',
                    label: '',
                },
                {
                    key: 'content',
                    label: 'Messages',
                },

                {
                    key: 'created_at',
                    label: 'Received',
                },
                {
                    key: 'user_id',
                    label: 'Sender',
                },
            ],
            emptyText: '<h4>There are no messages</h4>',
        }
    },
    filters: {
        displayTime(time, isShort) {
            if (isShort) {
                return time.split(' ')[0]
            }
            return moment(time, 'YYYY-MM-DD HH:mm:ss').format(
                'dddd, MMMM Do YYYY, h:mm:ss a'
            )
        },
        displayUser(user) {
            if (user) {
                const name = user.first_name + ' ' + user.last_name
                return (user.is_customer_user ? 'Client' : 'Agent') + ':' + name
            } else {
                return 'self'
            }
        },
    },
    computed: {
        order() {
            return this.$store.state.orders.item
        },
        messages() {
            return this.$store.state.orderMessagesStore.messages
        },
    },
    watch: {
        'order.notes': {
            //load items
            handler: function (messages) {
                this.$store.dispatch('orderMessagesStore/load', messages)
            },
            deep: true,
        },
    },
    mounted() {
        const { notes } = this.order
        this.$store.dispatch('orderMessagesStore/load', notes || [])
    },
    methods: {
        viewNote(item) {
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isModalVisible = true
        },

        createMessage() {
            const {
                model: { content },
            } = this
            const message = { content }
            this.$store.dispatch('orderMessagesStore/merge', message)
            this.isModalVisible = false;
        },
        deleteMessage(hash) {
            this.$store.dispatch('orderMessagesStore/delete', hash)
        },
    },
}
</script>

<style lang="scss" scoped>
</style>